import React, { useState } from "react";
import { updateSheet, deleteSheet } from "../api.js";
import ContactsGrid from "./ContactsGrid.jsx";

export default function SheetRow({ sheet, onChange }) {
  const [editing, setEditing] = useState(false);

  async function handleSave(updatedNames, updatedPhones) {
    const updated = await updateSheet(sheet._id, updatedNames, updatedPhones);
    onChange(updated);
    setEditing(false);
  }

  function handleClear() {
    // local clear is handled inside ContactsGrid; you can save after clearing
  }

  async function remove() {
    await deleteSheet(sheet._id);
    onChange({ _id: sheet._id }, true);
  }

  return (
    <div>
      <div>{/* <strong>Sheet:</strong> {sheet._id} */}</div>

      {editing ? (
        <ContactsGrid
          initialNames={sheet.names}
          initialPhones={sheet.phones}
          onSave={handleSave}
          onClear={handleClear}
        />
      ) : (
        <>
          <div>
            {Array.from({ length: 30 }).map((_, i) => (
              <div key={i}>
                <span style={{ fontSize: "25px" }}>
                  <strong>Ramadan # {i + 1} </strong> Name:{" "}
                  <b style={{ fontSize: "27px" }}>{sheet.names[i] || " "}</b>
                </span>{" "}
                |{" "}
                <span style={{ fontSize: "25px" }}>
                  Phone:{" "}
                  <b style={{ fontSize: "27px" }}>{sheet.phones[i] || " "}</b>
                </span>
              </div>
            ))}
          </div>
        </>
      )}

      <div>
        {editing ? (
          <button
            style={{
              marginLeft: "15px",
              padding: "10px 20px",
              fontSize: "16px",
              borderRadius: "5px",
              border: "none",
              backgroundColor: "#e1d30bff",
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => setEditing(false)}
          >
            Cancel
          </button>
        ) : (
          <button
            style={{
              margin: "40px",
              padding: "10px 20px",
              fontSize: "16px",
              borderRadius: "5px",
              border: "none",
              backgroundColor: "#63A361",
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => setEditing(true)}
          >
            Edit
          </button>
        )}
        <button
          style={{
            marginLeft: "550px",
            marginBottom: "40px",
            padding: "10px 20px",
            fontSize: "16px",
            borderRadius: "5px",
            border: "none",
            backgroundColor: "#d20a0aff",
            color: "white",
            cursor: "pointer",
          }}
          onClick={remove}
        >
          Delete
        </button>
      </div>
    </div>
  );
}
